import { ContactClass } from 'app/utility/enums';
import { ContactType, SalesStatus, ContactOrderBy } from "app/utility/enums";

export class ContactSearchParamsModel {
    contactType: ContactType;
    contactClass: ContactClass;
    salesStatus: SalesStatus = SalesStatus.None;
    searchText: string;
    
    pageSize: number;
    pageNumber: number;

    orderByIn: ContactOrderBy;
    orderByDesc: boolean = false;

    filterByAccountOwnerId: boolean = false;
    
    dateFrom: string = '1900-01-01';
    dateTo: string = '2999-12-31';
    enforce: boolean;
}